// removed by extract-text-webpack-plugin
module.exports = {"label":"_2dz9ef2u1vw6xrj5284gxywxsa67u3a695u5gb7t86ucg92tu1csvtf23jnyaj57rut6xn8j63839az3k7dvsjgsebaysww6vv7hxd6-InputRadios-module-label"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InputRadios/InputRadios.module.scss
// module id = 581
// module chunks = 0